function onVariantChange(container, variantId, sectionId, productUrl) {
    console.log("Selected variant ID: " + variantId);

    // Update URL with variant parameter
    const url = new URL(window.location);
    url.searchParams.set('variant', variantId);
    window.history.replaceState({}, '', url);

    fetch(`${productUrl}?variant=${variantId}&section_id=${sectionId}`)
        .then(response => response.text())
        .then(data => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(data, 'text/html');

            // Update Product Price and RRP Elements
            const newPriceElement = doc.querySelector('.main-product__price__container');
            const priceElement = container.querySelector('.main-product__price__container');

            if (newPriceElement && priceElement) {
                priceElement.innerHTML = newPriceElement.innerHTML;
                const discountContainer = container.querySelector('.main-product__variants__discount');

                if (discountContainer) {
                    const newPrice = newPriceElement.querySelector('.main-product__price').textContent.replace(/[^0-9.]/g, '');
                    const newCompareAtPriceElement = newPriceElement.querySelector('.main-product__compare-at-price').textContent.replace(/[^0-9.]/g, '');
                    
                    if (discountContainer.classList.contains('percentage')) {
                        const discount = Math.round((1 - (parseFloat(newPrice) / parseFloat(newCompareAtPriceElement))) * 100);
                        discountContainer.textContent = `(${discount}% off)`;
                    } else if (discountContainer.classList.contains('fixed-amount')) {
                        const discount = (parseFloat(newCompareAtPriceElement) - parseFloat(newPrice)).toFixed(2);
                        discountContainer.textContent = `(Save $${discount})`;
                    }
                }
            }

            // Update Add to Cart Button
            const atcButton = container.closest('.main-product__content')?.querySelector('atc-button');
            atcButton.setAttribute('variant-id', variantId);

            // Update atc-overlay  
            const atcOverlay = doc.querySelector('.atc-overlay__content');
            const existingAtcOverlay = document.querySelector('.atc-overlay__content');
            if (atcOverlay && existingAtcOverlay) {
                existingAtcOverlay.innerHTML = atcOverlay.innerHTML;
            }
            
            // Update the page title
            const newTitle = JSON.parse(doc.getElementById(`${sectionId}-${variantId}-title`).textContent || '{}');
            if (newTitle && newTitle.title) {
                document.title = newTitle.title;
            }
            // Select all other variant pickers to update their ARIA state 
            container.parentElement.querySelectorAll('variant-picker').forEach(variantElement => {
                const variantElementID = variantElement.getAttribute('data-variant-id');

                variantElement.setAttribute('aria-selected', variantElementID === variantId ? 'true' : 'false');
                variantElement.setAttribute('data-selected', variantElementID === variantId ? 'true' : 'false');
            });
        });
    }

window.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.main-product__variants__container').forEach(container => {
        const sectionId = container.getAttribute('data-section-id');
        const productId = container.getAttribute('data-product-id');
        const productUrl = container.getAttribute('data-url');

        container.querySelectorAll('.main-product__variant').forEach(variantElement => {
            const input = variantElement.querySelector(`input[name="${sectionId}${productId}"]`);

            if (variantElement.classList.contains('disabled')) {
                input.disabled = true;
            } else {
                input.addEventListener('change', function(event) {
                    const selectedVariantId = event.target.value;
                    onVariantChange(container, selectedVariantId, sectionId, productUrl);
                    
                    event.target.parentElement.setAttribute('aria-selected', event.target.checked ? 'true' : 'false');
                });
            }
        });
    });
});
